var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008555(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 33C65 15.3269 50.6731 1 33 1C15.3269 1 1 15.3269 1 33C1 50.6731 15.3269 65 33 65",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0016 50.8627C42.0616 50.6079 42.1574 50.3719 42.36 50.1925C42.8364 49.7706 43.4759 49.8008 43.952 50.2733C44.9428 51.2544 45.9321 52.2369 46.9198 53.2208C46.962 53.2696 47.0012 53.321 47.037 53.3746C47.0956 53.301 47.1258 53.2547 47.164 53.2167C49.458 50.9376 51.7522 48.6589 54.0467 46.3805C54.3891 46.0402 54.7847 45.9139 55.2551 46.0599C55.9548 46.2768 56.2351 47.1959 55.7744 47.7622C55.7204 47.8294 55.6629 47.8937 55.6021 47.9548C53.0338 50.5051 50.4654 53.0561 47.8971 55.6076C47.552 55.9506 47.1515 56.0982 46.6811 55.9309C46.5069 55.866 46.3486 55.765 46.2169 55.6346C44.9285 54.3668 43.649 53.0904 42.3644 51.8183C42.1704 51.6262 42.0578 51.3959 42 51.1348L42.0016 50.8627Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5003 50.4494L33.5003 50.4481C33.5105 47.2838 34.4589 44.1935 36.2253 41.5682C37.9918 38.9428 40.4971 36.9001 43.4244 35.6985C46.3517 34.4969 49.5696 34.1902 52.6711 34.8174C55.7727 35.4445 58.6186 36.9773 60.8491 39.2218C63.0796 41.4664 64.5945 44.3219 65.2022 47.4274C65.8099 50.5328 65.4831 53.7487 64.2631 56.6685C63.0432 59.5882 60.9849 62.0806 58.3485 63.8306C55.7121 65.5806 52.616 66.5095 49.4517 66.4999H49.4504C47.3477 66.4988 45.2659 66.0821 43.3247 65.2739C41.3835 64.4656 39.6212 63.2817 38.139 61.7902C36.6568 60.2987 35.4839 58.5289 34.6879 56.5827C33.8918 54.6364 33.4882 52.5521 33.5003 50.4494Z",
    fill: "#F7B53C",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50.5L46.0858 54.5858C46.8668 55.3668 48.1332 55.3668 48.9142 54.5858L57.5 46",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9.5V31C33 32.1046 32.1046 33 31 33H16.5",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008555);
export default __webpack_public_path__ + "static/media/Group 1000008555.ed6b085cfb8f01e5b8c3b6d4fd09bfcf.svg";
export { ForwardRef as ReactComponent };